// Ścieżki kolekcji Firestore w jednym miejscu.
//
// Wcześniej literał `artifacts/default-app-id/users/${userId}/containers` był
// wklejony w 12 miejscach w trzech plikach. Literówka w którymkolwiek z nich
// oznaczałaby ciche zapisywanie danych do nieistniejącej kolekcji — bez błędu,
// bo Firestore tworzy kolekcje w locie.

const APP_ID = process.env.REACT_APP_ID || 'default-app-id';

export const userRootPath = (userId) => `artifacts/${APP_ID}/users/${userId}`;

export const containersPath = (userId) => `${userRootPath(userId)}/containers`;

export const stocksPath = (userId) => `${userRootPath(userId)}/stocks`;
